/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ConsultBGImage from '../../assets/img/new-design/consult-bg-img.png';
import saw_sidebar_ebook from '../../assets/img/saw_sidebar_ebook.png';
import { baseUrl } from '../../config';
import { getConsultantBadges } from '../../store/actions/consultantDetails.action';
import * as leadAction from '../../store/actions/lead.action';
import * as types from '../../store/actions/types';
import { RootState } from '../../store/reducers';
import { historyPath, historyPush, isValidEmail, sawEBook, updateUser } from '../../utils/handler';
import { BOXConsultantDetails, ContributedDomains, NumberInput, StatisticsDetails } from '../components/CommonPages';
import { AgentDetails } from '../types/agentDetailsQuestions';
import { leadPayloadForm } from '../types/lead.types';

export const AgentDetailsQuestions: React.FC = (): JSX.Element => {
  const history = useHistory();
  const [preferredContact, setPreferredContact] = useState('Email');
  const [preferText, setPreferText] = useState(false);
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState('');
  const [offerAmount, setOfferAmount] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [phoneValidationError, setPhoneValidationError] = useState('');
  const [loaderBtn, setLoaderBtn] = useState(false);
  const [preferredTime, setPreferredTime] = useState<string | number | Date | null | any>(null);
  const [callAt, setCallAt] = useState('Morning');
  const [badges, setBadges] = useState([]);
  const [beSeen, setBeSeen] = useState('');
  const [deadLine, setDeadLine] = useState<string | number | Date | null | any>(null);
  const [marketAnalysis, setMarketAnalysis] = useState('');
  // const [ebookLoader, setEbookLoader] = useState<boolean>(false)
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { leadAssignedAgent, leadDetails = { preferredTime: '', consultantUID: '', consultant: {}, domainName: '', offerAmount: '', questionsAny: '', preferredContact: 'Email' } } = useSelector((state: RootState) => state.leadReducer);
  const [consultant] = useState<AgentDetails>(leadAssignedAgent);
  const { myProfile } = useSelector((state: RootState) => state.userReducer);
  useEffect(() => {
    if (badges.length === 0)
      getConsultantBadges(leadDetails.consultantUID).then((response) => {
        if (response) setBadges(response);
      });
    if (!leadDetails.domainName) {
      historyPush(historyPath.dashboard);
    } else {
      setOfferAmount(leadDetails.offerAmount ? leadDetails.offerAmount.toString() : '');
      setPreferredContact(leadDetails.preferredContact || '');
      setPhone(myProfile.phone || '');
      setEmail(myProfile.email || '');
      setPreferText(leadDetails.preferText);
      setBeSeen(leadDetails.beSeen || false);
      setMarketAnalysis(leadDetails.marketAnalysis || '');
      let leadDeaDLine = leadDetails.deadLine; //|| nextTwoMonth
      if (leadDeaDLine) {
        setDeadLine(new Date(leadDeaDLine));
      }
      if (leadDetails.preferredTime && leadDetails.preferredTime !== 'Invalid date') {
        let callTime = moment(leadDetails.preferredTime).format('HH.mm') === '14.30' ? 'Noons' : 'Mornings';
        setPreferredTime(new Date(leadDetails.preferredTime));
        setCallAt(callTime);
      }
    }
  }, [myProfile, leadDetails, history]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (isFormValid()) {
      setLoaderBtn(true);
      const payload: leadPayloadForm = {
        isSurveyCompleted: true,
        offerAmount,
        preferredContact,
        preferText,
        phone,
        email,
      };
      if (moment(preferredTime).isValid()) {
        payload.preferredTime = moment(preferredTime).utc().format();
      }
      if (marketAnalysis !== leadDetails.marketAnalysis) {
        payload.marketAnalysis = marketAnalysis;
      }
      if (beSeen !== leadDetails.beSeen) {
        payload.beSeen = beSeen || '';
      }
      if (deadLine !== leadDetails.deadLine) {
        payload.deadLine = deadLine;
      }

      const leadUID = leadDetails?.UID;
      await updateUser(email, phone, myProfile)
        .then(async (res) => {
          if (res) {
            let leadResponse = await leadAction.updateLead(leadUID, payload);
            if (leadResponse) {
              dispatch({ type: types.LEAD_DETAILS, payload: { ...leadDetails, ...payload, phone, email } });
              historyPush(historyPath.dashboard);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });

      setFormSubmitted(false);
      setLoaderBtn(false);
    }
  };

  const isFormValid = () => {
    if (preferredContact === 'Phone') {
      if (!phone) {
        setPhoneValidationError('Please Enter Phone number');
        return false;
      } else if (phone && !isValidPhoneNumber(phone)) {
        setPhoneValidationError('Invalid phone number');
        return false;
      }
    }
    if (preferredContact === 'Email' && (email === '' || isValidEmail(email))) {
      return false;
    }

    return preferredContact ? true : false;
  };

  const phoneNumberChange = (value: any) => {
    if (!value || (value && isValidPhoneNumber(value))) {
      setPhoneValidationError('');
    }
    if (formSubmitted && value && !isValidPhoneNumber(value)) {
      setPhoneValidationError('Invalid phone number');
    }
    setPhone(value);
  };
  const handlerPreferenceTime = (type: string) => {
    let preferTime = new Date(new Date(preferredTime || new Date()).setHours(type === 'Mornings' ? 8 : 14, 30));
    setPreferredTime(preferTime);
    setCallAt(type);
  };

  return (
    <>
      <Helmet>
        <title>Agent Details - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <div className="ash-bg pt-0 text-center">
        <img alt="" className=" consultant-bg-img" src={ConsultBGImage}></img>

        <div className="fs-23 mt-4">
          <span>Congratulations - you’ve taken the first step to acquiring your perfect domain!</span>
        </div>
        <div className="title mt-3">
          <span>Introducing your personal Saw.com domain consultant…</span>
        </div>
        <div className="">
          <div className="container d-lg-flex ">
            <div className="agent-card mx-auto">{BOXConsultantDetails(consultant)}</div>
            <div className="agent-context">
              <p>
                Hi, I’m <span className="f-bold bold-in-between">{consultant?.name}</span> - and I’m here to help your business purchase a premium domain for the best price. The role of a <span className="f-bold bold-in-between">Saw.com</span> consultant (like me!) is to learn more about your situation, guide you through the domain acquisition process and, more than anything, give you a potential price for up to 5 separate domains.
              </p>
              <p>
                If you fill in the form below and let me know how to contact you, I’ll do some digging into <span className="f-bold bold-in-between">{leadDetails.domainName}</span> and get back to you with information about the registrant, value and timeline for purchase. With more than 5 years of domain-buying experience and 250+ transactions under my belt, you’re in safe hands!
              </p>
              <div className="agent-badges">
                {badges.map((badge: { badgeName: string }, index: number) => (
                  <img key={index} className={'agent-badge ' + (badge.badgeName.includes('FIT') ? 'c-pointer' : '')} data-toggle="tooltip" title={badge.badgeName.includes('FIT') ? t('Highly experienced in acquiring social media handles for clients.') : ''} alt={baseUrl + badge.badgeName} src={baseUrl + badge.badgeName}></img>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" container  mt-5">
        <div className="row">
          <div className="col-md-12 col-lg-6 mb-4">
            <div className="title"> Help me go the extra mile for your domain acquisition…</div>
            <div>
              <p className="">
                <span className="theme-color">All questions are optional</span>, but providing as much detail as possible will allow me to positively influence pricing and negotiations!
              </p>
            </div>
            <form onSubmit={submit} noValidate>
              <div className="">
                <label className="mt-2 fw-600">{t('Do you have a budget in mind?')}</label>
                <NumberInput
                  name="offerAmount"
                  value={offerAmount}
                  placeholder="$"
                  onChange={(e) => {
                    setOfferAmount(e.target.value);
                  }}
                />

                {/* <input
                  autoComplete="off"
                  type="number"
                  className="form-control saw-input"
                  name="offerAmount"
                  placeholder="$"
                  onKeyDown={(e) => {
                    [189, 69, 109, 187, 107].includes(e.keyCode) && e.preventDefault();
                  }}
                  value={offerAmount}
                  min={0}
                  onChange={(e) => {
                    setOfferAmount(e.target.value);
                  }}
                /> */}
                <label className="mt-2 fw-600">{t(`Have you contacted the domain owner or seller before and what was the result?`)}</label>
                <input autoComplete="off" type="text" className="form-control saw-input" name="beSeen" value={beSeen || ''} onChange={(e) => setBeSeen(e.target.value)} />
                <label className="mt-2 fw-600">{t('Do you have a deadline?')}</label>
                <DatePicker minDate={new Date()} isClearable selected={deadLine} className="form-control saw-input" onChange={(date: Date) => setDeadLine(date)} />
                <label className="mt-2 fw-600">Any other information you think might be useful?</label>
                <input autoComplete="off" type="text" className="form-control saw-input" name="marketAnalysis" value={marketAnalysis || ''} onChange={(e) => setMarketAnalysis(e.target.value)} />
                <div className="contact-info-label">
                  <div className="fw-600">Contact Preference:</div>
                  <div className="contact-info-value ">
                    <div className="form-check form-check-inline  ">
                      <input className="form-check-input " checked={preferredContact === 'Phone Call'} onChange={() => setPreferredContact('Phone Call')} type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                      <label className="form-check-label  " htmlFor="inlineRadio1 ">
                        {t('Phone Call')}
                      </label>
                    </div>
                    <div className="form-check form-check-inline ml-3">
                      {/* <input name="preferText" type="checkbox" checked={preferText} onChange={() => setPreferText(!preferText)} className=" form-check-input " /> */}
                      <input className="form-check-input " checked={preferredContact === 'Phone Text'} onChange={() => setPreferredContact('Phone Text')} type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                      <label className="form-check-label">{t('Phone Text')}</label>
                    </div>
                    <div className="form-check form-check-inline ml-3">
                      <input className="form-check-input " checked={preferredContact === 'Email'} onChange={() => setPreferredContact('Email')} type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                      <label className="form-check-label " htmlFor="inlineRadio2">
                        {t('Email')}
                      </label>
                    </div>
                  </div>
                </div>
                {preferredContact === 'Email' ? (
                  <div className="cantact-details mt-2">
                    {/* <div><span className="fw-600"> {t("Email")}</span></div> */}
                    <div className="d-flex mt-3">
                      <input autoComplete="off" type="email" className="form-control saw-input  " name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div className="invalid-feedback">{t('Please Enter Valid Email')}</div>
                    {isValidEmail(email) || (email === '' && formSubmitted) ? <div className="text-danger fs-13">{t('Please Enter Valid Email')}</div> : null}
                  </div>
                ) : (
                  <div className="cantact-details mt-2 ">
                    <div className="phone-contact-details mt-3">
                      <PhoneInput international defaultCountry={localCountryStr} placeholder={t('Enter phone number')} value={phone} name="phone" onChange={(data) => phoneNumberChange(data || '')} className="form-control w100" />
                      {/* <div className="form-check mt-2 ml-1 fs-14 custom-checkbox">
                        <input name="preferText" type="checkbox" checked={preferText} onChange={() => setPreferText(!preferText)} className="saw-check-box form-check-input " />
                        <label className="fw-600 form-check-label">{t('Phone Text')}</label>
                      </div> */}
                    </div>
                    {phoneValidationError !== '' && <div className="text-danger">{phoneValidationError}</div>}
                    {/* <div className="lh-20">
                                        <label className="mt-3 fst-italic fs-13 fs-italic">
                                            {t("Please note that any SMS and/or data fees may apply depending on your provider")}
                                        </label>
                                    </div> */}
                    <div className="form-row">
                      <label className="mt-2 fw-600">{t('Preferred Day and Time for contact if necessary')}</label>
                      <div className="form-row input-group">
                        <div className="col-md-6 col-sm-12 mt-2">
                          <DatePicker
                            placeholderText={t('MM/DD/YYYY')}
                            className="form-control saw-input"
                            selected={preferredTime}
                            minDate={new Date()}
                            onChange={(date) => {
                              setPreferredTime(date);
                            }}
                            dateFormat="MM/dd/yyyy"
                          />
                        </div>
                        <div className="col-md-6  col-sm-12 mt-2">
                          <select value={callAt} onChange={(e) => handlerPreferenceTime(e.target.value)} aria-label="Default select example" className="form-control saw-input">
                            <option selected value="Mornings">
                              {t('Morning')}
                            </option>
                            <option value="Noons">{t('Afternoon')}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="mt-5">
                  <hr />
                  <div className="row justify-content-center mt-3">
                    <button className="btn  fs-14  btn-grad" disabled={loaderBtn} onClick={submit}>
                      {loaderBtn ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : t('CONTINUE')}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-12 col-lg-6 ">
            <div className=" ash-bg p-4 e-book-section ">
              <div className="m-2 ">
                <label className="sub-title title-border">{t('Download Your Free “Guide To Purchasing a Domain Name”')} </label>
                <div className="e-book">
                  <div className="text-center ">
                    <img className="e-book-img" alt="E-book" src={saw_sidebar_ebook}></img>
                  </div>
                  <div className=" mt-2">
                    <p>
                      Written by <span className="bold-in-between f-bold"> Jeffrey M. Gabriel, CEO of Saw.com</span>, this book explains why domain names are important, which one might be right for you and how to start the purchase process. It even shares some of Jeff’s experience in negotiating the price of domain names and explains how to seal the deal!
                    </p>
                    <form method="get" action="file.doc">
                      <a href={sawEBook} download="saw-e-book.pdf" className="btn btn-grad-outline theme-color book-link">
                        {t('Download E-book')}
                      </a>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 text-center agent-detail">
          <div className="mt-5">
            <ContributedDomains />
          </div>
          <StatisticsDetails />
        </div>
      </div>

      {/* <div className="content-body">
                <div className="container">
                    <div className="f-bold title ">{t("Here is your personal Saw.com Domain Broker:")}</div>
                    <div className="row	">
                        <div className="col-md-7 agent-details">

                            <div className="mt-4 mb-2">
                                <Avatar size={'100'} textSizeRatio={5} round={true}
                                    name={getAgentName(consultant)}
                                    src={getUserImageURL(consultant?.image)}
                                />
                                <label className="consultant-details">
                                    <div className="agent-name">{getAgentName(consultant)}</div>
                                    <div className="agent-role">
                                        {t("Domain Broker")}
                                    </div>
                                </label>

                            </div>
                            <div className=" w80 agent-badges" >
                                {badges.map((badge: { badgeName: string }, index: number) =>
                                    <img key={index} className={"agent-badge " + (badge.badgeName.includes("FIT") ? "c-pointer" : "")} data-toggle="tooltip"
                                        title={badge.badgeName.includes("FIT") ? t("Highly experienced in acquiring social media handles for clients.") : ""}
                                        alt={baseUrl + badge.badgeName} src={baseUrl + badge.badgeName}></img>
                                )}
                            </div>
                        </div>
                        <div className="col-md-5  second-half">
                            <div className="header-question">
                                <div className="f-bold sub-title ">{t("Some questions for you:")}</div>
                                <p className="pt-2 sub-title ash-color">
                                    {t("Buyer Interview")}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div> */}
    </>
  );
};

export default AgentDetailsQuestions;
